(function () {
    // save the section id from the script tag and find the section
    const sectionID = document.currentScript.dataset.id;
    const section = document.querySelector(`#${sectionID}`);

    // exit if section is not found
    if (!section) {
        console.warn(`Product section with ID ${sectionID} not found.`);
        return;
    }

    // get product data
    const product = JSON.parse(section.querySelector(".productJSON").textContent);

    // note, the starting activeVariant is set in the section liquid file, when options are changed we fetch the new variant data from the server
    let activeVariant = JSON.parse(section.querySelector(".productVariantJSON").textContent);
    let quantity = 1;

    // during dev mode, set the active variant to the window so it can be accessed in the console
    if (Shopify.theme.role === "development") {
        window.product = product;
        window.activeVariant = activeVariant;
    }

    /************
     Product Swiper
     ************/

        // check for variant swipers
    const multipleSwiper = !!section.querySelector('.productVisualSwiperGroup');

    // initialize variable for if single swiper
    let productSwiper = null;
    if (multipleSwiper) {
        section.querySelectorAll(".productVisualSwiperGroupItem").forEach(el => {
            const variantSwiper = new Swiper(el.querySelector(".productVisualSwiper"), {
                slidesPerView: 1,
                spaceBetween: 20,
                autoHeight: true,
                on: {
                    slideChange: function () {
                        if (!el.querySelector(".productVisualSwiperSlide")) {
                            return;
                        }
                        // update the thumbnail active class
                        el.querySelector(".productVisualThumbsSlide.active").classList.remove("active");
                        el.querySelectorAll(".productVisualThumbsSlide")[this.realIndex].classList.add("active");
                    }
                }
            });

            // change slide on thumbnail click
            el.querySelectorAll(".productVisualThumbsSlide").forEach(element => {
                element.addEventListener("click", function () {
                    // change slide
                    variantSwiper.slideTo(this.dataset.index - 1);
                });
            });
        })
    } else {
        productSwiper = new Swiper(section.querySelector(".productVisualSwiper"), {
            slidesPerView: 1,
            spaceBetween: 20,
            autoHeight: true,
            on: {
                slideChange: function () {
                    if (!section.querySelector(".productVisualSwiperSlide")) {
                        return;
                    }
                    // update the thumbnail active class
                    section.querySelector(".productVisualThumbsSlide.active").classList.remove("active");
                    section.querySelectorAll(".productVisualThumbsSlide")[this.realIndex].classList.add("active");

                    // pause all videos
                    section.querySelectorAll(".productVisualSwiperSlide video").forEach(element => {
                        element.pause();
                    });
                }
            }
        });

        // play video on slide play click
        section.querySelectorAll(".productVisualSwiperSlide").forEach(element => {
            element.addEventListener("click", function () {
                // get video
                const video = this.closest(".productVisualSwiperSlide").querySelector("video");

                if (!video) {
                    return;
                }

                // remove play button if it hasn't already been removed
                this.querySelector(".productVisualSwiperSlidePlay")?.remove();

                // show controls
                video.controls = true;

                // play video
                video.play();
            });
        });

        // change slide on thumbnail click
        section.querySelectorAll(".productVisualThumbsSlide").forEach(element => {
            element.addEventListener("click", function () {
                // change slide
                productSwiper.slideTo(this.dataset.index - 1);
            });
        });
    }

    /*****************
     Nutritional Label
     ******************/

    if (section.querySelector('.productOptionsItemButton')) {
        // image dialog
        const imageDialog = section.querySelector('.productOptionsItemButtonDialog');

        // dialog swiper
        const labelSwiper = new Swiper(imageDialog.querySelector('.productOptionsItemButtonDialogImageSwiper'), {
            slidesPerView: 1,
            spaceBetween: 20,
            autoHeight: true,
            navigation: {
                prevEl: imageDialog.querySelector(".swiper-button-prev"),
                nextEl: imageDialog.querySelector(".swiper-button-next"),
            },
        })

        // closing events
        imageDialog.addEventListener("close", () => document.querySelector('body').classList.remove('noScroll'))
        imageDialog.addEventListener("click", function (e) {
            if (e.target === this) this.close();
            if (e.target.classList.contains('productOptionsItemButtonDialogClose')) this.close();
        })

        // create an array for finding index
        const labelSlides = Array.from(imageDialog.querySelectorAll('.swiper-slide'));
        section.querySelector('.productOptionsItemButton').addEventListener('click', async function () {
            // check if a slide has variant id to match active and show that first
            if (imageDialog.querySelector(`.productOptionsItemButtonDialogImageSwiperSlide[data-id="${String(activeVariant.id)}"]`)) {
                // get index of slide and slide to it
                const index = labelSlides.findIndex(el => el.dataset.id === String(activeVariant.id));
                labelSwiper.slideTo(index);
            }
            // open dialog
            document.querySelector('body').classList.add('noScroll');
            imageDialog.showModal();
        })

    }

    /**************
     Update Product
     ***************/

    // update section on input change to match variant
    section.querySelectorAll("input, select").forEach(function (element) {
        element.addEventListener("change", async function () {

            // if this is an option, update the active variant
            if (this.classList.contains("productOptionsItemValuesLabelInput")) {

                // create array of selected option ids
                const optionIDs = [];
                section.querySelectorAll(".productOptionsItemValuesLabelInput:checked").forEach(element => {
                    optionIDs.push(element.dataset.id);
                })

                // fetch updated variant data
                const response = await fetch(`/products/${product.handle}?view=active-variant&option_values=${optionIDs.join(',')}`)
                    .then(response => response.json());

                // update active variant
                activeVariant = response.active_variant;
            }

            // if variant change, update the variant description
            if (this.dataset.description) {
                this.closest(".productItemGroup").querySelector('.productOptionsItemDescription').textContent = this.dataset.description;
            }

            // update the closest label - flavor name ex.
            const label = this.closest('.productItemGroup')?.querySelector('.productLabel');
            if (label) {
                label.querySelector('span').textContent = this.dataset.label;
            }

            // variety can only be a 2 pouch selection
            if (this.value === 'variety' || this.classList.contains('productQuantityGroupItemInput')) {
                // if variety pack chosen, ensure the 2 quantity is chosen
                if (varietyChosen()) {
                    section.querySelector('.productQuantityGroupItemInput[value="2"]').click();
                }
            }

            // close and clear the calculator if open, reset the amounts
            if (section.querySelector('.productQuantityCalc')) {
                section.querySelector('.productQuantityCalc').classList.remove('active');
                section.querySelectorAll('.productQuantityCalcSelectionItemUpdate')?.forEach((el, index) => {
                    el.dataset.amount = String(index === 0 ? 1 : 0);
                    el.querySelector('.productQuantityCalcSelectionItemUpdateDisplay').textContent = String(index === 0 ? 1 : 0);
                })
                section.querySelector('.productQuantityCalcRecommendAmount').textContent = "1 Pouch";
            }

            // update product
            updateProduct().catch((err) => console.error(err));
        });
    })

    function isSubscription() {
        return !!section.querySelector(`.productSellingOptionInput[value="sub"]:checked`);
    }

    function currentSellingPlan() {
        return parseInt(section.querySelector('.productSellingOptionPlanValue')?.value) || null;
    }

    function varietyChosen() {
        return section.querySelector('.productOptionsItemValuesLabelInput:checked')?.value === 'variety';
    }

    // mark first run, keeps main image first - not variant image
    let firstRun = true;

    async function updateProduct() {

        // check if variant wasn't found (null would be returned from the fetch)
        if (!activeVariant) {
            section.querySelector(".productATC").disabled = true;
            section.querySelector(".productATCText").textContent = "Not Available";
            return;
        }

        /*********
         Quantity
         **********/

        if (section.querySelector('.productQuantityGroupItemInput')) {
            quantity = parseInt(section.querySelector('.productQuantityGroupItemInput:checked').value) || 1;
        }

        // if variety, quantity is 2 for price update
        quantity = varietyChosen() ? 2 : quantity;

        /**************
         Variant Image
         ***************/

        // change active slide
        if (multipleSwiper) {
            // hide all other swipers and show relevant one
            const comparison = varietyChosen() ? "variety" : activeVariant.id.toString();
            section.querySelectorAll('.productVisualSwiperGroupItem')?.forEach(el => {
                el.dataset.id === comparison
                    ? el.classList.add('active')
                    : el.classList.remove('active');
            })
        } else if (activeVariant.featured_image && !firstRun && productSwiper) {
            if (varietyChosen()) {
                productSwiper.slideTo(productSwiper.slides.length - 1);
            } else {
                productSwiper.slideTo(activeVariant.featured_image.position - 1);
            }
        }

        /**************
         Price
         ***************/

        // if there's a subscription we need to update both prices
        if (product.selling_plan_groups.length > 0) {
            // Select both sets of elements at once
            const compares = section.querySelectorAll(".productSellingOptionHeaderPriceCompare");
            const reals = section.querySelectorAll(".productSellingOptionHeaderPriceReal");

            // Destructure them for clarity:
            // Assuming the markup is structured so that index 0 is for subscription, index 1 for one-time purchase
            const [subCompare, oneTimeCompare] = compares;
            const [subReal, oneTimeReal] = reals;

            // if there are quantity selectors, special behavior
            if (section.querySelector('.productQuantityGroupItemInput:checked')) {
                // Update subscription prices
                subCompare.textContent = price(activeVariant.price * quantity, true);
                subReal.textContent = section.querySelector('.productQuantityGroupItemInput:checked').dataset.price + "/mo";
                // update the percent off
                const savings = section.querySelector('.productQuantityGroupItemInput:checked + .productQuantityGroupItemInner .productQuantityGroupItemServings')?.textContent.toLowerCase().replace(" off", "") || "20%";
                section.querySelector('.productSellingOptionHeaderTitleSavings span').textContent = savings;
                oneTimeReal.textContent = price(activeVariant.price * quantity, true);
            } else {
                const allocationPrice = activeVariant.selling_plan_allocations[0].price;

                // Update subscription prices
                if (activeVariant.price > allocationPrice) {
                    subCompare.textContent = price(activeVariant.price);
                }
                subReal.textContent = price(allocationPrice);

                // Update one-time purchase prices
                if (activeVariant.compare_at_price > activeVariant.price) {
                    oneTimeCompare.textContent = price(activeVariant.compare_at_price);
                }
                oneTimeReal.textContent = price(activeVariant.price);
            }

        } else {
            // Non-subscription scenario
            const compareEl = section.querySelector(".productSellingOptionHeaderPriceCompare");
            const realEl = section.querySelector(".productSellingOptionHeaderPriceReal");

            if (activeVariant.compare_at_price > activeVariant.price) {
                compareEl.textContent = price(activeVariant.compare_at_price, true);
            }
            realEl.textContent = price(activeVariant.price, true);
        }


        // update price - if quantity selectors, special behavior
        if (section.querySelector('.productQuantityGroupItemInput:checked')) {
            section.querySelector(".productATCPrice").textContent = isSubscription() ? section.querySelector('.productQuantityGroupItemInput:checked').dataset.price : price(activeVariant.price * quantity, true);
        } else {
            section.querySelector(".productATCPrice").textContent = isSubscription() ? price(activeVariant.selling_plan_allocations[0].price * quantity, true) : price(activeVariant.price * quantity, true);
        }

        // if subscription, reveal price per pouch
        if (section.querySelector('.productQuantityGroup')) {
            isSubscription()
                ? section.querySelector('.productQuantityGroup').classList.remove('hide')
                : section.querySelector('.productQuantityGroup').classList.add('hide');
        }

        /**************
         ATC Enable/Disable
         ***************/

        // check if the variant is in stock
        if (activeVariant.available) {
            section.querySelector(".productATC").disabled = false;
            section.querySelector(".productATCText").innerHTML = "Order now";
        } else {
            section.querySelector(".productATC").disabled = true;
            section.querySelector(".productATCText").textContent = "Sold Out";
        }

        /*************
         Update Sticky
         *********/

            // update url with variant id so the selected options are maintained on refresh
        let url = new URL(window.location.href);
        url.searchParams.set("variant", activeVariant.id);
        window.history.replaceState({}, "", url);
    }

    // on load, update the product
    // this accomplishes loading the correct variant image and price on page load
    updateProduct().catch((err) => console.error(err));
    firstRun = false;

    /**************
     Product ATC
     ***************/

    async function addToCart() {

        // add loading animation to both buttons
        section.querySelector(".productATC").classList.add("loading");

        // check if subscription
        const hasSubscription = isSubscription();
        // get subscription plan
        let subPlanId = hasSubscription ? currentSellingPlan() : null;
        // if pack specific subscriptions, apply based on quantity size
        if (section.querySelector('.productQuantityGroupItemInput[data-plan]')) {
            // fall back to generic plan
            subPlanId = parseInt(section.querySelector('.productQuantityGroupItemInput:checked')?.dataset?.plan) || subPlanId;
        }

        let formData = [];

        // clear cart
        await fetch("/cart/clear.js");

        // check for selling plan and gift
        gifts?.forEach(gift => {
            const giftId = parseInt(gift.id);
            if (!giftId) return;
            if (hasSubscription || !gift.sub) {
                formData.push(
                    {
                        quantity: 1,
                        id: giftId,
                    }
                )
            }
        })

        if (varietyChosen()) {
            section.querySelectorAll('.productOptionsItemValuesLabelInput:not([value="variety"])').forEach(el => {
                formData.push({
                    quantity: 1,
                    id: parseInt(el.dataset.variant),
                    selling_plan: hasSubscription ? subPlanId : null
                })
            })
        } else {
            formData.push({
                quantity: quantity,
                id: activeVariant.id,
                selling_plan: hasSubscription ? subPlanId : null
            })
        }

        // add product
        await addProduct({items: formData});

        // remove loading animation
        section.querySelector(".productATC").classList.remove("loading");

        // open cart
        // await openCart();
        // temp
        document.location.href = '/checkout';
    }

    section.querySelector('.productATC').addEventListener("click", addToCart);

    /**************************
     Product Quantity Calculator
     ***************************/

    if (section.querySelector('.productQuantityCalc')) {
        // open the calculator
        section.querySelector('.productQuantityCalcButton')?.addEventListener('click', () => {
            // reset to one pouch suggestion first
            section.querySelector('.productQuantityGroupItemInput[value="1"]').click();
            section.querySelector('.productQuantityCalc').classList.add('active');
        });

        // close the calculator
        section.querySelector('.productQuantityCalcClose')?.addEventListener('click', () => {
            section.querySelector('.productQuantityCalc').classList.remove('active');
        });

        section.querySelectorAll('.productQuantityCalcSelectionItemUpdateButton')?.forEach(button => {
            button.addEventListener('click', function () {
                const parent = this.closest('.productQuantityCalcSelectionItemUpdate');
                // number selected
                let amount = parseInt(parent.dataset.amount);
                if (this.classList.contains('productQuantityCalcSelectionItemUpdateMinus')) {
                    if (amount > 0) {
                        amount -= 1;
                    }
                } else if (this.classList.contains('productQuantityCalcSelectionItemUpdatePlus')) {
                    amount += 1;
                }
                // update the display and the dataset amount
                parent.dataset.amount = String(amount);
                parent.querySelector('.productQuantityCalcSelectionItemUpdateDisplay').textContent = String(amount);

                // calculate recommendation
                let total = 0;
                section.querySelectorAll('.productQuantityCalcSelectionItemUpdate').forEach(el => {
                    total += (parseFloat(el.dataset.value) * parseInt(el.dataset.amount));
                })
                // update the recommendation
                if (total >= 2.5) {
                    section.querySelector('.productQuantityCalcRecommendAmount').textContent = "3 Pouches";
                } else if (total >= 1.5) {
                    section.querySelector('.productQuantityCalcRecommendAmount').textContent = "2 Pouches";
                } else {
                    section.querySelector('.productQuantityCalcRecommendAmount').textContent = "1 Pouch";
                }
            })
        })
    }

    /**************
     Product FAQs
     ***************/

    // add faq information opening
    if (section.querySelector('.productFaqs')) {
        const buttons = section.querySelectorAll('.productFaqsItemsButton');
        buttons?.forEach(button => {
            button.addEventListener('click', function () {
                buttons.forEach(el => {
                    el === this ? el.classList.toggle('active') : el.classList.remove('active');
                });
            })
        })
    }

    /**************
     Product Videos
     ***************/

    // video handling
    if (section.querySelector('.productVideos')) {

        // video handling
        const sectionVideosSlides = Array.from(document.querySelectorAll('.productVideosSwiperSlide'));
        if (sectionVideosSlides.length > 0) {
            section.querySelectorAll('.productVideosSwiperSlideButton')?.forEach(button => {
                button.addEventListener('click', async function () {
                    const video = this.closest('.productVideosSwiperSlide').querySelector('.productVideosSwiperSlideVideo');
                    if (!video) return;
                    if (this.classList.contains('active')) {
                        await video.pause();
                        this.classList.remove('active');
                        return;
                    }
                    // pause all videos and reset buttons
                    await pauseAllVideos().catch(console.error);
                    await video.play();
                    this.classList.add('active');
                })
            })
        }

        async function pauseAllVideos() {
            if (sectionVideosSlides.length > 0) {
                for (let i = 0; i < sectionVideosSlides.length; i++) {
                    await sectionVideosSlides[i].querySelector('.productVideosSwiperSlideVideo').pause();
                    sectionVideosSlides[i].querySelector('.productVideosSwiperSlideButton').classList.remove('active');
                }
            }
        }

        // listen for video end
        section.querySelectorAll('.productVideosSwiperSlideVideo')?.forEach(video => {
            video.addEventListener('ended', function () {
                this.closest('.productVideosSwiperSlide').querySelector('.productVideosSwiperSlideButton').classList.remove('active');
            })
        })

        // swiper
        new Swiper(section.querySelector(".productVideosSwiper"), {
            slidesPerView: 'auto',
            spaceBetween: 12,
            navigation: {
                prevEl: section.querySelector(".productVideosTopNavButton.swiper-button-prev"),
                nextEl: section.querySelector(".productVideosTopNavButton.swiper-button-next"),
            },
            pagination: {
                el: section.querySelector(".productVideosSwiperPagination"),
                clickable:
                    true,
            },
            on: {
                slideChange: () => pauseAllVideos().catch(console.error)
            }
        })

    }

}());